import "./StatSplitBar.scss";

type StatSplitBarProps = {
  correctPercent: number;
  correctLabel: string;
  incorrectLabel: string;
  variant?: "default" | "neutral";
};

const StatSplitBar = ({
  correctPercent,
  correctLabel,
  incorrectLabel,
  variant = "default",
}: StatSplitBarProps) => (
  <div className={`stat-split-bar stat-split-bar--${variant}`}>
    <div className="stat-split-bar__track">
      <div className="stat-split-bar__fill" style={{ width: `${correctPercent}%` }} />
    </div>
    <div className="stat-split-bar__legend">
      <span>
        <span className="stat-split-bar__dot stat-split-bar__dot--correct" />
        {correctLabel}
      </span>
      <span>
        <span className="stat-split-bar__dot stat-split-bar__dot--incorrect" />
        {incorrectLabel}
      </span>
    </div>
  </div>
);

export default StatSplitBar;
